export default __webpack_public_path__ + "static/media/Saintly Protector.9e207498.jpg";